<template>
	<div class="department">
		<div>
			<el-select v-model="depId"
						v-show="$store.state.isSystemAdminMode"
						class="menu-select"
						@change="handleDepSelect" >
        		<el-option
          			v-for="dep in departmentListWithAll"
          			:key="dep.id"
          			:label="dep.title"
          			:value="dep.id">
				</el-option>
      		</el-select>
		</div>
		<div class="department-table">
			<el-col class="title-bar" style="display:block;">
				<div class="number-of-deps">{{ '共 ' + this.actualDepartments.length + ' 個部門' }}</div>
				<el-button class="add-btn" @click="showAddDialog">新增部門
					<img src="../../assets/icon/ic_add.png" alt="A" class="add-icon">
				</el-button>
			</el-col>
			<el-table :data="actualDepartments" 
					v-loading="listLoading"
					row-key="id"
					:default-sort="{prop: 'depid'}"
					empty-text="暫無數據" 
					style="display:inline-block; float: left;">
				<el-table-column prop="name" label="部門">
				</el-table-column>
				<el-table-column label="隸屬">
					<template slot-scope="scope">
						{{ scope.row.dep.title }}
					</template>
				</el-table-column>
				<el-table-column prop="number" label="會員人數"> 
	
				</el-table-column>
				<el-table-column label="可不列入統計的會員比例上限(％)" :formatter="formatExclude"> 
				</el-table-column>
				<el-table-column width="100px">
					<template slot-scope="scope">
						<img src="../../assets/icon/ic_delete_blue.png" alt="D" class="delete-icon" @click="handleDelete(scope.$index, scope.row)">
						<img src="../../assets/icon/ic_edit_blue.png" alt="E" class="edit-icon" @click="showEditDialog(scope.row)">
					</template>
				</el-table-column>
			</el-table>
		</div>
		<alert v-show="alert.display && this.$store.state.nowDepartmentStatus === 1"
		 	:warning="alert.warning" :content="alert.content" :title="alert.title" 
			@close="closeAlert" @delete="deleteDepartment()">
		</alert>
		<hint v-show="hint.display && this.$store.state.hintStatus.department" 
			:message="hint.message" @close="closeHint">
		</hint>
		<el-dialog  :title="dialogTitle" :show-close="false" :visible.sync="dialogFormVisible" customClass="dialogWidth">
			<el-form :model="form" :rules="rules" ref="form" label-position="top">
				<el-form-item label="部門名稱" prop="name">
					<el-input v-model="form.name"></el-input>
				</el-form-item>
				<el-form-item label="隸屬" prop="depId">
					<el-select v-model.number="selectedDep" placeholder="請選擇隸屬" style="width:100%" @change="depSel">
						<el-option v-for="dep in departmentList" :key="dep.id" :label="dep.title" :value="dep.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="可不列入統計的會員比例上限(％)" prop="limit">
					<el-input v-model.number="form.limit"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button @click="dialogFormVisible = false">取消</el-button>
				<el-button v-if="isEditDialog" type="primary" @click="editActualDep">儲存</el-button>
				<el-button v-else type="primary" @click="addActualDep">新增</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { DepartmentModel } from '@/common/js/data';
import API from "../../api/api";
export default {
	name: "Department",
  	data() {
		var checkException = (rule, value, callback) => {
			if ( value < 0 || value > 100) {
				callback(new Error('請輸入0~100'));
			} else {
				callback();
			}
		};
		return {
			listLoading: false,
			depId: 0,
			actualDepartmentsAll: [],
			actualDepartments: [],
			alert: {
        		title: '',
        		content: '',
        		display: false,
        		inputs:['部門名稱','隸屬'],
				inputDepName: '',
				inputDepId: null,
        		placeholder:['請填入文字','請選擇']
			},
			isEdit: false,
			updateRow: null,
			originalName: '',
			hint: {
				message: '',
				display: false,
			},
			timer: null,
			departmentModel: null,
			dialogFormVisible: false,
			isEditDialog: false,
			dialogTitle: '',
			departmentList: [],
			departmentListWithAll: [],
			selectedDep: null,
			form: {
				id: null,
				name: '',
				depId: null,
				limit: 0,
			},
			rules: {
				name: [
					{ required: true, message: '請輸入部門名稱', trigger: 'blur' },
				],
				depId: [
					{ required: true, message: '請選擇隸屬' },
				],
				limit: [
					{ required: true, message: '請輸入比例上限' },
					{ type: "number", message: "請輸入數字", trigger: "blur" },
					{ validator: checkException, trigger: 'blur' },
				],
			},

		}
	},
  	created() {
		if (!this.$store.state.isBackendMode) {
			this.$router.push({ path: '/table' });
			return;
		}
    	this.initial();
  	},
  	methods: {
		async initial() {
			this.$store.state.nowStatus = 10;
			this.departmentModel = new DepartmentModel();
			this.listLoading = true;
			this.departmentList = await this.departmentModel.getDepartmentList();
			this.departmentListWithAll = JSON.parse(JSON.stringify(this.departmentList));
			let defaultAll = { 
				'id': 0,
				'title': '全部'
			};
			this.departmentListWithAll.unshift(defaultAll);
			this.reloadActualDeps();
		},
		async reloadActualDeps() {
			this.listLoading = true;
			this.actualDepartmentsAll = await this.departmentModel.reloadActualDeps();
			this.handleDepSelect(this.depId);
			this.listLoading = false;
		},
		formatExclude: function (row, column) {
			return row.limit + "%(" + row.exclude_limit + "人)";
		},
		handleDepSelect: function(key) {
			this.actualDepartments = this.actualDepartmentsAll.filter(function (e) {
				if (key === 0) {
					return e; 
				} 
				return e.depid === key;
			});
	    },
		closeAlert: function() {
			this.alert.display = false;
			this.$store.state.nowDepartmentStatus = 0;
		},
		handleDelete: function(index, row) {
			this.alert.display = true;
			this.alert.title = '刪除部門';
			this.$store.state.nowDepartmentStatus = 1;
			this.updateRow = row;
			this.alert.content = '您確定要刪除' + ' "' + row.name + '"?';
		},
		deleteDepartment: function() {
			if (this.updateRow.number > 0) {
				this.showHint('該部門尚有會員，無法刪除!');
			} else {
				API.deleteActualDep(this.updateRow.id).then((response) => {
					if(response.status) {
						redirectLogin(response.data);
						if(!JSON.parse(response.request.response).error_msg) {
							this.showHint('刪除部門錯誤!');
						} else {
							this.showHint(JSON.parse(response.request.response).error_msg);	
						}
					} else {
						this.showHint('刪除部門成功!');
						this.$store.state.nowDepartmentStatus = 0;
						let i1 = this.actualDepartments.map(item => item.id).indexOf(this.updateRow.id);
						this.actualDepartments.splice(i1, 1)
						let i2 = this.actualDepartmentsAll.map(item => item.id).indexOf(this.updateRow.id);
						this.actualDepartmentsAll.splice(i2, 1);
					}
				});
			}
		},
		showAddDialog() {
			this.dialogTitle = "新增部門";
			this.isEditDialog = false;
			this.form = {
				id: null,
				name: '',
				depId: null,
				limit: 0,
			};
          	this.selectedDep = null;
			this.showDialog();
		},
		showEditDialog(item) {
			this.dialogTitle = "編輯部門";
			this.isEditDialog = true;

			this.form = {
				id: item.id,
				name: item.name,
				depId: item.dep.id,
				limit: item.limit,
			};
			this.selectedDep = this.form.depId;
			this.showDialog();
		},
		showDialog() {
			this.dialogFormVisible = true;
			if (this.$refs["form"] !== undefined) {
				this.$refs["form"].resetFields();
			}
		},
		closeHint: function() {
				this.hint.display = false;
				this.$store.state.hintStatus.department = false;
				clearTimeout(this.timer);
		},
		showHint: function(message) {
			if(this.timer) {
				clearTimeout(this.timer);	
			}
			this.hint.display = true;
			this.hint.message = message;	
			this.$store.state.showHint = true;
			this.$store.state.hintStatus.department = true;
			this.timer = setTimeout(() => {
				if(this.$store.state.showHint) {
					this.$store.state.showHint = false;
					this.$store.state.hintStatus.department = false;
				}
			}, this.$store.state.fadeOutTime);
		},
		depSel(val) {
			this.form.depId = val;
		},
		addActualDep() {
			this.$refs["form"].validate((valid) => {
				if (valid) {
					API.addActualDep(this.form.name, this.form.depId, this.form.limit).then((response) => {
						if(response.status) {
							redirectLogin(response.data);
							if(!JSON.parse(response.request.response).error_msg) {
								this.showHint('新增部門錯誤!');
							} else {
								this.showHint(JSON.parse(response.request.response).error_msg);	
							}
						} else {
							this.showHint('新增部門成功!');
							this.reloadActualDeps();
						}
						this.dialogFormVisible = false;
					});
					
				} else {
					return false;
				}
			});
		},
		editActualDep() {
			this.$refs["form"].validate((valid) => {
				if (valid) {
					API.updateActualDep(this.form.id, this.form.name, this.form.depId, this.form.limit).then((response) => {
						if(response.status) {
							redirectLogin(response.data);
							if(!JSON.parse(response.request.response).error_msg) {
								this.showHint('修改部門錯誤!');
							} else {
								this.showHint(JSON.parse(response.request.response).error_msg);	
							}
						} else {
							this.showHint('修改部門成功!');
							this.reloadActualDeps();
						}
						this.dialogFormVisible = false;
					});
					
				} else {
					return false;
				}
			});
		},
	},
};
</script>

<style lang="scss">
$font-color: #222222;
$border-color: #EEE;
$background-color: #FFFFFF;
$button-color: #2E90F4;

.department {
	.menu-select {
		.el-input__inner{
			border-color: #B6B6B6;
			background-color: white;
			border-radius: 2px;
			font-size: 14px;
			font-weight: 500;
			color: #222;
			line-height: 24px;
			margin-top: 9px;	
		}

		.el-input__icon{
			width: 40px;
			margin-top: 4px;
			color: #626874;
		}
	
		.el-input__suffix {
			&:before {
				content: '';
				position: absolute;
				left: 0;
				height: 32px;
				width: 1px;
				background-color: rgba(151, 151, 151, .35);
				margin-top: 7px;
			}
		}

		.el-icon-arrow-up {
			&:before {
				color: #a7a7a7;
				content: '\25B2';
			}
		}
	}

	.department-table {
		margin-top: 30px; 
		display: block;
		.hint {
			font-size: 15px;	
			text-align: center;
			margin-bottom: 5px;
		}
		.title-bar {
			background: $background-color;
			border-top: 1px solid $border-color;
			border-left: 1px solid $border-color;
			border-right: 1px solid $border-color;
			height: 54px;
			float: left;
			.number-of-deps {
				font-size: 14px;
				color: #626874;
				line-height: 24px;
				margin-top: 15px;
				margin-left: 16px;
				float: left;
			}
			.add-btn {
	    	float: right;
	    	display: block;
	    	background: $button-color;
				border-radius: 2px;
				border: none;
				color: #fff;
				font-size: 14px;
				height: 36px;
				margin-right: 16px;
				white-space: normal;
				margin-top: 9px;
				width: 120px;
				.add-icon {
					height: 14px;
					width: 14px;
					float: left;
				}
			}
			.add-btn:hover {
	    		background: #42A0FF;
			}	
		}	
		
		.el-table {
			font-size: 14px;
			color: $font-color;
			cursor: default;
			background: $background-color;
			.edit-icon {
				display: none;
				height: 16px;
				width: 16px;
				margin-top:4px;
				float: right;
				margin-right:5%;
				cursor: pointer;
			}
			.delete-icon {
				display: none;
				height: 16px;
				width: 16px;
				margin-top:4px;
				float: right;
				cursor: pointer;
			}
			.cancel-btn {
				display: block;
				float: right;
				margin-right:5%;
			}
			.save-btn {
				display: block;
				float: right;
			}

		}

		.el-table--enable-row-hover .el-table__body tr:hover td {
			.edit-icon {
				display: block;
				height: 16px;
				width: 16px;
				margin-top:4px;
				float: right;
				margin-right:25px;
				cursor: pointer;
			}
			.delete-icon {
				display: block;
				height: 16px;
				width: 16px;
				margin-top:4px;
				float: right;
				cursor: pointer;
			}
		}	
	}

	.dialogWidth {
      width: 450px;
    }
}
</style>


// WEBPACK FOOTER //
// Department.vue?e1e51e8e